import { View, StyleSheet, TouchableOpacity, FlatList } from 'react-native';
import React from 'react';
import Accordion from '../../accordion/Accordion';
import Typography from '../../typography/Typography';
import { AccordionArrow, ColorTokens, FontFamilyTokens, FontSizeTokens, IconTokens } from '@voltmoney/schema';
import { AccordionData } from './Data';
const FAQScreen = ({ navigatetoFaq, triggerAction }) => {
    const handlePress = () => {
        if (navigatetoFaq) {
            triggerAction(navigatetoFaq);
        }
    };
    const renderItem = ({ item, index }) => {
        return (React.createElement(View, { nativeID: `acd_landingScreen_faq${item.id}` },
            React.createElement(Accordion, { title: item.title, description: item.description, icon: IconTokens.DownArrow, rightIcon: AccordionArrow.RIGHT, mainScreen: true, hideDivider: index === 5 ? true : false })));
    };
    return (React.createElement(View, { style: styles.container },
        React.createElement(View, { style: styles.FAQText },
            React.createElement(Typography, { label: "FAQs", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 }),
            React.createElement(TouchableOpacity, { onPress: handlePress },
                React.createElement(Typography, { id: 'txt_landingScreen_viewAll', label: "View all", fontSize: FontSizeTokens.SM, fontWeight: '600', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Primary_100, lineHeight: 20 }))),
        React.createElement(View, { style: styles.accordionContainer }, React.createElement(FlatList, { data: AccordionData, renderItem: renderItem, keyExtractor: (item) => item.id }))));
};
export default FAQScreen;
const styles = StyleSheet.create({
    container: {
        marginTop: 24,
        marginBottom: 84,
        backgroundColor: 'white',
    },
    accordionContainer: {
        paddingHorizontal: 16,
        paddingTop: 16,
    },
    FAQText: {
        paddingHorizontal: 16,
        paddingTop: 16,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    }
});
